export function updateTotal(price, count) {
    const totalSum = document.querySelector('.catalog-detail__purchase-total');
    const totalSpan = totalSum?.querySelector('span');
    if (!totalSpan) {
        return;
    }
    const hasExtra = count > 1;

    if (hasExtra) {
        totalSpan.textContent = (price * count).toLocaleString('ru-RU') + ' ₽';
        totalSum.classList.add('active');
    } else {
        totalSum.classList.remove('active');
    }
}
